<template>
  <div>
    <div >
      <el-dialog :close-on-click-modal="false"
        :title="title"
        :visible.sync="addProDialogVisible"
        :before-close="addProHandleClose"
        width="49rem"
        center
      >
        <div class="content">
          <el-form
            :model="ruleForm"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item label="餐桌编号：">
              <el-input v-model="ruleForm.name" maxlength="6" oninput ="value=value.replace(/[^0-9.]/g,'')" placeholder="请输入"></el-input>
            </el-form-item>
          </el-form> 
           <div class="contentBtns">
            <!-- <div>重置</div> -->
            <div @click="btns">确认保存</div>
           </div>
        </div>
      </el-dialog>
      <el-dialog :close-on-click-modal="false"
        title="餐桌二维码"
        :visible.sync="addProDialogVisible1"
        :before-close="addProHandleClose"
        width="43.7rem"
        center
      >
        <div class="content">
          <div class="images">
            <img :src="erweima" alt="">
          </div>
        </div>
      </el-dialog>
    </div>
    <div></div>
  </div>
</template>
<script>
import {Message} from "element-ui"
import {WftableAdd,WftableGetCode,WftableUpdate,WfcodeList} from '@/request/scenic.js'
export default {
  props:['restaurantid'],
  data() {
    return {
      addProDialogVisible: false,
      addProDialogVisible1:false,
      title:'',
     
      ruleForm:{
        name:'',
      },
      erweima:''
    };
  },
  methods: {
    btns(){
      if(this.name==''){
        Message.error('请输入桌位号');
        return false
      }
      if(this.ruleForm.id){
        this.ruleForm.name = this.ruleForm.name
        this.ruleForm.token=window.sessionStorage.getItem('Token')
        WftableUpdate(this.ruleForm).then(res=>{
          if(res.data.status=='ok'){
              this.$emit('close')
              Message.success('修改成功')
              this.addProDialogVisible = false
          }else{
            Message.error(res.data.msg)
          }
        })
      }else{
        let data = {
          name:this.ruleForm.name,
          restaurantid:this.restaurantid,
          token:window.sessionStorage.getItem('Token')
        }
        WftableAdd(data).then(res=>{
          if(res.data.status=='ok'){
              this.$emit('close')
              Message.success('添加成功')
              this.addProDialogVisible = false
          }else{
            Message.error(res.data.msg)
          }
        })
      }
    },
    pxFn(e,row,index) {
      if(e==1){
        this.title = '添加桌位'
        if(row){
          this.ruleForm = row
        }
        this.addProDialogVisible = true;
      }else{
        if(row.qrcode==''){
          let data = {
            restaurantid:row.restaurantid,
            id:row.id,
            method:index,
            token:window.sessionStorage.getItem('Token')
          }
          WftableGetCode(data).then(res=>{
            if(res.data.status=='ok'){
              this.erweima = res.data.result
            }
          })
        }else{
          // let da = {
          //   rid:row.restaurantid,
          //   token:window.sessionStorage.getItem('Token')
          // }
          // WfcodeList(da).then(res=>{
          //   if(res.data.status=='ok'){
          //     if(res.data.result!=null){
            console.log(row,123456)
                this.erweima = row.qrcode
        //       }
        //     }
        //   })
        }
        this.addProDialogVisible1 = true;
      }
    },
    addProHandleClose(){
      this.addProDialogVisible = false
      this.addProDialogVisible1 = false
      this.$emit('close')
    }
  },
};
</script>

<style lang="less" scoped>
::v-deep .el-dialog__body {
  padding: 2rem 0 !important;
  border-top: 1px solid #e5e5ea;
}
.content{
  padding: 0 2rem 2rem 2rem;
  box-sizing: border-box;
  .contentBtns{
    margin-top: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    div{
      width: 10rem;
      height: 4rem;
      border-radius: 4px;
      line-height: 4rem;
      text-align: center;
      color: #fff;
      font-size: 1.4rem;
      cursor: pointer;
     
        background: #246DEB;
    }
  }
}
.images{
  width: 100%;
  height: 35.7rem;
  img{
    width: 100%;
    height: 35.7rem;
  }
}
</style>